import { defineCustomElements } from "@storebrand-digital/recorder";
import { addFocusOutlineListeners } from "Utils/FocusOutlineHandler";
import { initAuth } from "Utils/KeycloakWrapper";
import { initSentry } from "Utils/initSentry";
import { initialize as initializeNavbarAndFooter } from "Utils/navbarAndFooter/navbarAndFooterUtils";
import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";

async function bootstrap(): Promise<void> {
  await initAuth();

  initSentry();
  addFocusOutlineListeners();
  initializeNavbarAndFooter();

  const rootElement = document.getElementById("root");
  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(<App />);
    if (process.env.RECORD) {
      defineCustomElements();
    }
  }
}

export default bootstrap;
